<template>
  <div class="ai-disclaimer-box">
    <v-icon size="16" color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
    <span class="disclaimer-text">{{ t('aiAssistant.disclaimer') }}</span>
  </div>
</template>

<script setup>
import { useInternationalization } from '@/composables/use-internationalization';

const { t } = useInternationalization();
</script>

<style lang="scss" scoped>
.ai-disclaimer-box {
  display: flex;
  align-items: center;
  background: rgba(var(--v-theme-warning), 0.12);
  border-left: 3px solid rgb(var(--v-theme-warning));
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 24px;
  max-width: 500px;

  .disclaimer-text {
    font-size: 12px;
    color: rgba(var(--v-theme-on-surface), 0.8);
    line-height: 1.4;
  }
}
</style>
